import { ViewHeader, InfoBox, Card, Pagination, Table, useGet, Help } from '@enkla-gui'
import { icons } from '@config'
import { invoicebasehelper, date, notify } from '@/_helpers'
import { useParams } from 'react-router-dom'
import { Tabs } from 'antd';


export default function Job() {
  let { id } = useParams()

  let { data: job } = useGet({ endpoint: `api/job/${id}` })
  let { data: successful, setPage, sorting, setSorting } = useGet({ endpoint: `api/job/${id}/successful` })
  let { data: failed, setPage: setPageFailed, setSorting: setSortingFailed } = useGet({ endpoint: `api/job/${id}/failed` })

  return (
    <>
      <ViewHeader
        title='Resultat av schemalagt jobb'
        subtitle={date.full(job?.created_at)}
        breadcrumbs={job?.breadcrumb}
        icon={icons.invoice}
      />

      <div class="row">
        <InfoBox
          title='typ av Jobb'
          subtitle={job?.job_type_label}
          icon={icons.job}
        />
        <InfoBox
          title='totalt Antal hyresavier'
          subtitle={failed?.total + successful?.total}
          icon={icons.invoice}
        />
        <InfoBox
          title='Behandlades utan fel'
          subtitle={successful?.total}
          icon={icons.success}
        />
      </div>
      <div class="col">
        <Tabs
          defaultActiveKey="2"
          style={{ margin: '0px 5px' }}
          items={[
            {
              key: 1,
              label: 'Åtgärdslog',
              icon: <i class={icons.log} />,
              children: (
                failed?.data?.length === 0 ? (
                  <Help type='info' title='Inga hyresavier kräver manuell åtgärd'>
                    <p>Alla hyresavier i jobbet har behandlats utan fel.</p>
                  </Help>
                ) : (
                  <Card >
                    <Table
                      rows={failed?.data}
                      link={`/#!/invoicebase/@{id}`}
                      sorting={sorting}
                      useSorting={sort => setSortingFailed({ ...sort })}
                      empty={{
                        text: 'Inga hyresavier kopplade till jobbet kräver manuell åtgärd',
                      }}
                      functions={{
                        status: status => <span class={`badge w-100 bg-${invoicebasehelper.status(status).color}`}>{invoicebasehelper.status(status).label}</span>,
                      }}
                      keys={[
                        'title',
                        'status>function:status',
                        'relation.error_event.description',
                      ]}
                      headers={[
                        {
                          key: 'invoice_type',
                          value: 'Typ',
                          sortable: true,
                          class: 'min'
                        },
                        {
                          key: 'status',
                          value: 'hyresavins aktuella status',
                          sortable: true,
                          class: 'min'
                        },
                        {
                          value: 'felmeddelande från körning (se hela meddelandet i hyresavins händelselog)'
                        },
                      ]}
                    />
                    <Pagination data={failed} fetch={setPageFailed} />
                  </Card>
                )
              )
            },
            {
              key: 2,
              label: 'Behandlades utan fel',
              icon: <i class={icons.success} />,
              children: (
                <Card>
                  <Table
                    rows={successful?.data}
                    link={`/#!/invoicebase/@{id}`}
                    sorting={sorting}
                    useSorting={sort => setSorting({ ...sort })}
                    functions={{
                      period: invoice => date.short(invoice.start) + ' - ' + date.short(invoice.stop),
                      status: status => <span class={`badge w-100 bg-${invoicebasehelper.status(status).color}`}>{invoicebasehelper.status(status).label}</span>,
                      success: relation => <span class={`badge w-100 bg-${relation.error_event_id ? 'danger' : 'success'}`}><i class={relation.error_event_id ? icons.error : icons.success} /></span>,
                    }}
                    keys={[
                      'title',
                      'status>function:status',
                      'due_at>date:short',
                      '_this>function:period',
                    ]}
                    headers={[
                      {
                        key: 'invoice_type',
                        value: 'Typ',
                        sortable: true,
                        class: 'min'
                      },
                      {
                        key: 'status',
                        value: 'hyresavins aktuealla Status',
                        sortable: true,
                        class: 'min'
                      },
                      {
                        value: 'Förfaller'
                      },
                      {
                        value: 'Period'
                      },
                    ]}
                  />
                  <Pagination data={successful} fetch={setPage} />
                </Card>
              )
            },
          ]}
        />
      </div>
    </>
  )
}
